var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudComputing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.234,
    height: 60.591,
    viewBox: "0 0 66.234 60.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b9e0e3;}.b{fill:#7e9395;}.c{fill:#fafafa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -21.823)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.994,38.83A20.709,20.709,0,0,0,27.562,22.264,21.152,21.152,0,0,0,11.046,43.026c0,.48.019.971.061,1.491A12.691,12.691,0,0,0,.07,58.568,12.55,12.55,0,0,0,12.425,70h1.448c-.033-.471-.069-.94-.069-1.42A18.2,18.2,0,0,1,31.732,50.124,18.2,18.2,0,0,1,49.66,68.58c0,.48-.036.948-.069,1.42h1.448a15.618,15.618,0,0,0,.954-31.17Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.656,0A13.656,13.656,0,1,1,0,13.656,13.656,13.656,0,0,1,13.656,0Z",
    transform: "translate(17.959 55.102)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.506 60.068)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M236.008,315.849a1.242,1.242,0,0,1-1.241-1.242v-14.9a1.242,1.242,0,0,1,2.483,0v14.9A1.242,1.242,0,0,1,236.008,315.849Z",
    transform: "translate(-229.817 -298.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M203.4,305.929a1.241,1.241,0,0,1-.879-.363l-4.087-4.089-4.087,4.089a1.241,1.241,0,0,1-1.755-1.755l4.966-4.966a1.241,1.241,0,0,1,1.755,0l4.966,4.966a1.242,1.242,0,0,1-.879,2.118Z",
    transform: "translate(-192.24 -298.48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudComputing);
export default __webpack_public_path__ + "static/media/cloud-computing.3538ddbc463c081b1cd112ab93ddbbb4.svg";
export { ForwardRef as ReactComponent };